import { httpClient } from '@/lib/http-client'
import { type PagedRequest, buildPagedParams } from '@/shared/types'

export const usersApi = {
    list: (params?: PagedRequest) =>
        httpClient.get('/users', { params: Object.fromEntries(buildPagedParams(params)) }),

    update: (id: string, data: any) => httpClient.put(`/users/${id}`, data),
    delete: (id: string) => httpClient.delete(`/users/${id}`),

    searchDirectory: (search?: string) =>
        httpClient.get('/users/directory', { params: { search: search || '' } }),

    provision: (data: any) => httpClient.post('/users/provision', data),
    importData: (form: FormData) =>
        httpClient.post('/users/import', form, {
            headers: { 'Content-Type': 'multipart/form-data' },
        }),
    exportUrl: (format: string) => `/api/users/export?format=${format}`,
}
